/* kl-popup.js v1.1 · 主题自带订阅弹窗 → Klaviyo 客户端订阅接口 · 2026-09-09
   读取 #kl-popup-config(JSON):company_id, list_id, code, text{}, img, img_pos, rules{}
   规则:购物车/结账/账户/政策页不弹;订阅过不再弹;关闭后 7 天不弹;桌面=退出意图|停留|滚动,手机=停留|滚动
   v1.1:页面上已有 Klaviyo 自带表单(弹窗)时让位不弹(并视同已关闭 7 天),避免双弹窗;订阅体显式带 email marketing consent */
(function () {
  if (window.__klpop) return; window.__klpop = 1;
  var cfgEl = document.getElementById('kl-popup-config'); if (!cfgEl) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.company_id || !cfg.list_id) return;
  /* 非 Shopify 站(WordPress):文案表 texts{en,de,...} 按 <html lang> 选 */
  if (!cfg.text && cfg.texts) { var lg = String(cfg.locale || document.documentElement.lang || 'en').toLowerCase(); cfg.text = cfg.texts[lg] || cfg.texts[lg.split('-')[0]] || cfg.texts.en; cfg.locale = lg; }
  if (!cfg.text) return;
  if (window.Shopify && window.Shopify.designMode && !cfg.preview) return;
  var path = location.pathname;
  if (/\/(cart|checkouts?|account|my-account|policies|orders|tools|apps)(\/|$)/.test(path)) return;
  var LS = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  var now = Date.now();
  if (LS.get('klp_done')) return;
  var closed = parseInt(LS.get('klp_closed') || '0', 10); if (closed && now - closed < (cfg.rules.closed_days || 7) * 864e5) return;
  if (cfg.customer_subscribed) return;
  var isMobile = !window.matchMedia || window.matchMedia('(max-width: 760px), (pointer: coarse)').matches;
  var shown = false, root = null, t1 = null, klOpen = false;
  /* Klaviyo 自带表单让位:其弹窗/侧滑打开 → 我们不弹(已弹则收起),并记 7 天;页内嵌入式表单不算 */
  function isFixed(n) { for (var i = 0; n && n !== document.body && i < 12; i++, n = n.parentNode) { try { if (getComputedStyle(n).position === 'fixed') return true; } catch (e) { return false; } } return false; }
  function klFormVisible() {
    if (klOpen) return true;
    var els = document.querySelectorAll('form[class*="klaviyo-form"],[data-testid^="klaviyo-form"]');
    for (var i = 0; i < els.length; i++) { var b = els[i].getBoundingClientRect(); if (b.width > 40 && b.height > 40 && isFixed(els[i])) return true; }
    return false;
  }
  window.addEventListener('klaviyoForms', function (e) {
    var t = e && e.detail && e.detail.type;
    if (t === 'open') { klOpen = true; shown = true; cleanup(); if (root) { close(); } else { LS.set('klp_closed', String(Date.now())); } }
    else if (t === 'close') { klOpen = false; }
  });

  function el(sel) { return root ? root.querySelector(sel) : null; }
  function show(reason) {
    if (shown) return;
    if (klFormVisible()) { shown = true; cleanup(); LS.set('klp_closed', String(Date.now())); return; }
    shown = true; cleanup();
    var tpl = document.getElementById('kl-popup-tpl'); if (!tpl) return;
    root = document.createElement('div'); root.className = 'klp'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', cfg.text.title);
    root.innerHTML = tpl.innerHTML; document.body.appendChild(root);
    var T = cfg.text || {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-t]'), function (n) { n.textContent = T[n.getAttribute('data-t')] || ''; });
    Array.prototype.forEach.call(root.querySelectorAll('[data-p]'), function (n) { n.setAttribute('placeholder', T[n.getAttribute('data-p')] || ''); });
    var xb = root.querySelector('.klp-x'); if (xb) xb.setAttribute('aria-label', T.close || 'Close');
    var img = el('.klp-img'); if (img && cfg.img) { img.style.backgroundImage = 'url("' + cfg.img + '")'; if (cfg.img_pos) img.style.backgroundPosition = cfg.img_pos; }
    requestAnimationFrame(function () { root.classList.add('klp-open'); });
    var inp = el('.klp-email'); if (inp && !isMobile) { setTimeout(function () { inp.focus(); }, 350); }
    root.addEventListener('click', function (e) {
      if (e.target.closest('.klp-x, .klp-no, .klp-done') || e.target === root) { close(); }
    });
    document.addEventListener('keydown', onKey);
    var form = el('form'); if (form) form.addEventListener('submit', submit);
    var cp = el('.klp-copy'); if (cp) cp.addEventListener('click', copy);
    try { if (window.klaviyo) { window.klaviyo.push(['track', 'Popup Shown', { reason: reason }]); } } catch (e) {}
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function close() {
    if (!root) return; root.classList.remove('klp-open'); document.removeEventListener('keydown', onKey);
    var r = root; root = null; setTimeout(function () { if (r && r.parentNode) r.parentNode.removeChild(r); }, 350);
    if (!LS.get('klp_done')) LS.set('klp_closed', String(Date.now()));
  }
  function setErr(msg) { var e = el('.klp-err'); if (e) { e.textContent = msg || ''; e.hidden = !msg; } }
  function submit(ev) {
    ev.preventDefault();
    var inp = el('.klp-email'), btn = el('.klp-cta'); var email = (inp && inp.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { setErr(cfg.text.err_email); if (inp) inp.focus(); return; }
    setErr(''); if (btn) { btn.disabled = true; btn.classList.add('klp-busy'); }
    var body = { data: { type: 'subscription', attributes: { custom_source: cfg.source || 'Site popup', profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }, properties: { 'Signup source': cfg.source || 'Site popup', 'Signup locale': cfg.locale || '' } } } } }, relationships: { list: { data: { type: 'list', id: cfg.list_id } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company_id), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' }, body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status === 202 || r.ok) { success(email); } else { return r.text().then(function (t) { throw new Error('HTTP ' + r.status + ' ' + t.slice(0, 120)); }); }
    }).catch(function (e) {
      setErr(cfg.text.err_generic); if (btn) { btn.disabled = false; btn.classList.remove('klp-busy'); }
      try { console.warn('kl-popup', e); } catch (x) {}
    });
  }
  function success(email) {
    LS.set('klp_done', String(Date.now()));
    try { if (window.klaviyo) { window.klaviyo.push(['identify', { email: email }]); } } catch (e) {}
    var a = el('.klp-state-form'), b = el('.klp-state-done'); if (a) a.hidden = true; if (b) b.hidden = false;
    var cd = el('.klp-code'); if (cd) cd.textContent = cfg.code || '';
  }
  function copy() {
    var code = cfg.code || ''; var b = el('.klp-copy');
    var done = function () { if (b) { b.textContent = cfg.text.copied; setTimeout(function () { b.textContent = cfg.text.copy; }, 1800); } };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, done); }
    else { try { var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); } catch (e) {} done(); }
  }
  /* ---- triggers ---- */
  var r = cfg.rules || {};
  function onScroll() {
    var h = document.documentElement, max = (h.scrollHeight - h.clientHeight) || 1;
    var pct = (window.scrollY || h.scrollTop) / max * 100;
    if (pct >= (isMobile ? (r.mobile_scroll_pct || 50) : (r.desktop_scroll_pct || 40))) show('scroll');
  }
  function onLeave(e) { if (e.clientY <= 0 && !e.relatedTarget) show('exit'); }
  function cleanup() { window.removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onLeave); if (t1) clearTimeout(t1); }
  function arm() {
    if (shown) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    if (!isMobile && r.exit_intent !== false) document.addEventListener('mouseout', onLeave);
    t1 = setTimeout(function () { show('timer'); }, (isMobile ? (r.mobile_delay_s || 15) : (r.desktop_delay_s || 12)) * 1000);
  }
  if (document.readyState === 'complete') { arm(); } else { window.addEventListener('load', function () { setTimeout(arm, 800); }); }
  window.__klpopShow = function () { show('manual'); };
})();
